module.exports = __webpack_public_path__ + "static/media/icon-sort.7d15f2d1.svg";